module.exports = __webpack_public_path__ + "static/media/bug-sync.b2ba8e45.svg";